import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AiSearchPatternViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  descriptionValue?: { displayId: string; id: string } | null;
  description: string;
  patternValue?: { displayId: string; id: string } | null;
  pattern: string;
  pathTypesValue?: { displayId: string; id: string } | null;
  pathTypes: string[];
  toolsValue?: { displayId: string; id: string } | null;
  tools: string[];
  effectivenessValue?: { displayId: string; id: string } | null;
  effectiveness: number | undefined;
  evaluationCountValue?: { displayId: string; id: string } | null;
  evaluationCount: number;
  successCountValue?: { displayId: string; id: string } | null;
  successCount: number;
  sourceEvalIdsValue?: { displayId: string; id: string } | null;
  sourceEvalIds: string[];
  proposedByValue?: { displayId: string; id: string } | null;
  proposedBy: string;
  activeValue?: { displayId: string; id: string } | null;
  active: boolean;
  priorityValue?: { displayId: string; id: string } | null;
  priority: number;
};

export const AiSearchPatternViewForm: React.FC<AiSearchPatternViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      description = "",
      pattern = "",
      pathTypes = [],
      tools = [],
      effectiveness = 0,
      evaluationCount = 0,
      successCount = 0,
      sourceEvalIds = [],
      proposedBy = "",
      active = false,
      priority = 0,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAiSearchPatternLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.AiSearchPatternNameLabel}
                />
                <ShowMultiLine
                  value={description}
                  label={langStore.AiSearchPatternDescriptionLabel}
                />
                <ShowMultiLine
                  value={pattern}
                  label={langStore.AiSearchPatternPatternLabel}
                />
                <ShowMultiLine
                  value={pathTypes}
                  label={langStore.AiSearchPatternPathTypesLabel}
                />
                <ShowMultiLine
                  value={tools}
                  label={langStore.AiSearchPatternToolsLabel}
                />
                <ShowNumber
                  value={effectiveness}
                  label={langStore.AiSearchPatternEffectivenessLabel}
                  decimalScale={2}
                />
                <ShowNumber
                  value={evaluationCount}
                  label={langStore.AiSearchPatternEvaluationCountLabel}
                />
                <ShowNumber
                  value={successCount}
                  label={langStore.AiSearchPatternSuccessCountLabel}
                />
                <ShowMultiLine
                  value={sourceEvalIds}
                  label={langStore.AiSearchPatternSourceEvalIdsLabel}
                />
                <ShowMultiLine
                  value={proposedBy}
                  label={langStore.AiSearchPatternProposedByLabel}
                />
                <ShowBoolean
                  value={active}
                  label={langStore.AiSearchPatternActiveLabel}
                />
                <ShowNumber
                  value={priority}
                  label={langStore.AiSearchPatternPriorityLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
